import { render, staticRenderFns } from "./PlatformToggle.vue?vue&type=template&id=1a567f31&scoped=true"
import script from "./PlatformToggle.vue?vue&type=script&lang=js"
export * from "./PlatformToggle.vue?vue&type=script&lang=js"
import style0 from "./PlatformToggle.vue?vue&type=style&index=0&id=1a567f31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a567f31",
  null
  
)

export default component.exports